import SyllabusScreen from "./SyllabusScreen";


export default SyllabusScreen;